import invariant from 'invariant';

let AppMixins = {
  methods: {
    generateBackground: function (data) {
      if(data instanceof Array ) {
        if (data.length === 1) {
          return {
            type: 'color',
            data: data[0].hex
          }
        } else if (data.length > 1) {
          let result = [];
          data.forEach(function (item){
            result.push(`${item.hex} ${item.location*100}%`)
          });
          result = result.join(' ,');
          return {
            type: 'gradient',
            data: `linear-gradient(to right,${result})`
          }
        }
      } else {
        invariant(false, 'generateBackgroundStroke needed Array');
      }
    },


    getHexFromColorArray: function (data, index) {
      if(data instanceof Array ) {
        return  data[index].hex;
      } else {
        invariant(false, 'getHexFromColorArray needed Array');
      }
    }
  }
};

export  {
  AppMixins
}
